import { BaseConfig } from '../ServiceConfig';

export interface CRMConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.CrmServiceConfigData';
  url: string;
}

export const CRMConfigurationFields: (keyof CRMConfiguration)[] = ['url'];

export const BlankCRMConfiguration: CRMConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.CrmServiceConfigData',
} as CRMConfiguration;
